import React, { useState, useRef, useEffect } from "react";
import ChangePasswordModal from "./ChangePasswordModal";
import "./UserMenu.css";

export default function UserMenu({ user, onLogout }) {
  const [open, setOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const ref = useRef(null);

  const initials = user.name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const firstName = user.name.split(" ")[0];

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleChangePasswordClick = () => {
    setOpen(false);
    setShowChangePassword(true);
  };

  const handleLogoutClick = () => {
    setOpen(false);
    onLogout();
  };

  return (
    <>
      <div className="topbar-user" ref={ref}>
        <button
          className="topbar-user-trigger"
          onClick={() => setOpen(!open)}
          title={`${user.name} (${user.role || "guest"})`}
        >
          <div className="user-avatar">{initials}</div>
          <span className="user-name">{firstName}</span>
          <span className="user-chevron">{open ? "▴" : "▾"}</span>
        </button>

        {open && (
          <div className="user-menu-dropdown">
            <div className="user-menu-header">
              <div className="user-menu-name">{user.name}</div>
              <div className="user-menu-role">{user.role || "guest"}</div>
            </div>
            <div className="user-menu-sep" />
            <button className="user-menu-item" onClick={handleChangePasswordClick}>
              Cambiar contraseña
            </button>
            <button className="user-menu-item user-menu-item--danger" onClick={handleLogoutClick}>
              Cerrar sesión
            </button>
          </div>
        )}
      </div>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </>
  );
}
